<template>
  <CreateUpdateCashierForm />
</template>

<script setup lang="ts"></script>
